const { same } = require('../utils');

exports.computeStyleFromCanvasItems = canvasItems => same(canvasItems, 'style', '');
